import React from "react";
import { OverlayTrigger } from "react-bootstrap";
import TimeRegistrationDayCardTopBar from "./TimeRegistrationDayCardTopBar";
import "./TimeRegistrationDayCard.scss";

/**
 * Vista móvil: una tarjeta por día natural, con bloques por cada registro (entrada/salida).
 * Reutiliza los mismos trozos que la tabla (tipo, turnos, menú, aprobación).
 */
const TimeRegistrationDayCard = ({
	segments,
	showWeekBoundary,
	isTodayCard,
	className = "",
	renderTimeInputs,
	shouldShowAddTime,
	onAddTime,
	getTimeType,
	getUbication,
	getActionsCell,
	getShiftList,
	getObservations,
	hasObservationsOrAttachments,
	renderApprovalControl,
}) => {
	return (
		<div
			className={[
				"time-registration-day-card",
				showWeekBoundary ? "time-registration-day-card--week-start" : "",
				isTodayCard
					? "time-registration-day-card--today time-registrations-today-row"
					: "",
				className,
			]
				.filter(Boolean)
				.join(" ")}
		>
			{segments.map(({ time, derived }, segIdx) => {
				const {
					isMain,
					disabled,
					hours,
					balance,
					tooltipInfo,
					day_type,
				} = derived;
				const shiftBlock = isMain ? getShiftList(time.day) : null;
				const actionsCell = getActionsCell(time, disabled);

				const balanceEl = tooltipInfo ? (
					<OverlayTrigger overlay={tooltipInfo}>
						<span
							className={[
								"time-registration-day-card__balance",
								balance.short_raw > 0 ? "color-green" : "",
								balance.short_raw < 0 ? "color-red" : "",
							]
								.filter(Boolean)
								.join(" ")}
						>
							{balance.short}
						</span>
					</OverlayTrigger>
				) : (
					<span
						className={[
							"time-registration-day-card__balance",
							balance.short_raw > 0 ? "color-green" : "",
							balance.short_raw < 0 ? "color-red" : "",
						]
							.filter(Boolean)
							.join(" ")}
					>
						{balance.short}
					</span>
				);

				return (
					<div
						key={`${time.id}-${segIdx}`}
						className={[
							"time-registration-day-card__segment",
							time.start !== null && time.start !== undefined
								? "time-registration-day-card__segment--filled"
								: "time-registration-day-card__segment--empty",
							derived.isMain
								? "time-registration-day-card__segment--main"
								: "time-registration-day-card__segment--follow",
						]
							.filter(Boolean)
							.join(" ")}
					>
						<div className="time-registration-day-card__top">
							<TimeRegistrationDayCardTopBar
								time={time}
								dayType={day_type}
								disabled={disabled}
								isMain={isMain}
								renderTimeInputs={renderTimeInputs}
								showAddButton={
									typeof shouldShowAddTime === "function"
										? shouldShowAddTime(time)
										: false
								}
								onAddTime={onAddTime}
								renderApprovalControl={renderApprovalControl}
							/>
						</div>

						<div className="time-registration-day-card__bottom">
							<div className="time-registration-day-card__bottom-row">
								<div className="time-registration-day-card__bottom-details">
									<div className="time-registration-day-card__tipo">
										{getTimeType(time, disabled)}
									</div>
									{typeof getUbication === "function" && (
										<div className="time-registration-day-card__ubicacion">
											{getUbication(time, disabled)}
										</div>
									)}

									<div className="time-registration-day-card__bottom-metrics">
										<span className="time-registration-day-card__segment-hours">
											{hours}
										</span>

										{isMain && (
											<span
												className={[
													"time-registration-day-card__balance-wrap",
													balance.short_raw > 0
														? "time-registration-day-card__balance-wrap--positive"
														: "",
													balance.short_raw < 0
														? "time-registration-day-card__balance-wrap--negative"
														: "",
												]
													.filter(Boolean)
													.join(" ")}
											>
												{balanceEl}
											</span>
										)}

										{hasObservationsOrAttachments(time) && (
											<span className="time-registration-day-card__obs">
												{getObservations(time)}
											</span>
										)}
									</div>
								</div>

								{actionsCell ? (
									<div className="time-registration-day-card__actions">
										{actionsCell}
									</div>
								) : null}
							</div>

							{shiftBlock && (
								<div className="time-registration-day-card__shifts-row">
									<div className="time-registration-day-card__shifts">
										{shiftBlock}
									</div>
								</div>
							)}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default TimeRegistrationDayCard;
